/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { Dispatcher } from 'flux'

class AppDispatcher extends Dispatcher {
  handleOnChange(event) {
    this.dispatch({
      type: 'value-changed',
      payload: {
        name: event.target.name,
        value: event.target.value
      }
    })
  }

  dispatchWithType(type, payload) {
    if (payload == null) payload = {}
    this.dispatch({
      type: type,
      payload: payload
    })
  }

  dispatchWithDelay(type, payload, delay) {
    setTimeout(() => {
      this.dispatchWithType(type, payload)
    }, delay)
  }

  promisedDispatch(type, payload) {
    return new Promise((resolve, reject) => {
      const dispatch = () => {
        try {
          const result = this.dispatchWithType(type, payload)
          resolve(result)
        } catch (error) {
          reject(error)
        }
      }

      // setTimeout(() => dispatch(), 100)
      dispatch()
    })
  }
}

export default new AppDispatcher()
